import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import GdvAccess from "@/shared/model/GdvAccess";
import GdvAccessListItemComponent from "@/modules/Gdv/components/GdvAccessListItemComponent.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
interface Props {
  data?:GdvAccess[];
}
//const _data = ref<GdvAccess[]>([])
// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'GdvAccessListComponent',
  props: {
    data: { default: undefined }
  },
  emits: ['editClicked', 'changePinClicked'],
  setup(__props: any, { emit: __emit }) {

const props = __props

async function onEdit(value:GdvAccess) {
  emit('editClicked',value)
}

async function onChangePin(value:GdvAccess) {
  emit('changePinClicked',value)
}

//const emit = defineEmits<{(e:'editClicked',gdvAccess:GdvAccess):void}>();
const emit = __emit



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogFlexRow, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item) => {
        return (_openBlock(), _createBlock(GdvAccessListItemComponent, {
          key: item,
          data: item
        }, {
          default: _withCtx(() => [
            _createVNode(SogCardActions, null, {
              default: _withCtx(() => [
                _createVNode(SogCardActionButton, {
                  ref_for: true,
                  ref: "btnSearch",
                  tooltip: "bearbeiten",
                  "mdi-icon": "mdi-pencil",
                  onClick: ($event: any) => (onEdit(item))
                }, null, 8, ["onClick"]),
                _createVNode(SogCardActionButton, {
                  ref_for: true,
                  ref: "btnSearch",
                  tooltip: "Password ändern",
                  "mdi-icon": "mdi-form-textbox-password",
                  onClick: ($event: any) => (onChangePin(item))
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["data"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})